export const ASSOCIATE_MEMBERSHIP = {
  INSIDER_PROGRAM: "insider-program-associate-discount",
  INSIDER_CONFIRM: "confirm your kohler associate discount",
}
export const PRIVACY_POLICY = {
  GOOGLE_PRIVACY: "google privacy policy",
  GOOGLE_TERMS: "terms of service",
}
